
// EmailJS configuration
export const EMAIL_CONFIG = {
  SERVICE_ID: 'service_jgaexqr',
  TEMPLATE_ID: 'template_pzoe1yh', 
  PUBLIC_KEY: 'bOZ86HOzL3ZdPQuAN'
};

export const RECIPIENT_EMAIL = 'info@classbuddy.nl';
